export const fieldsToCopy = [
  "diagnosis_icd",
  "diagnosis_icd_other",
  "doctors_notes",
  "examination_abnormal",
  "examination_abnormal_conditions",
  "examination_facial_volume",
  "examination_facial_volume_details",
  "examination_fitzpatrick_skin_type",
  "examination_glogau_skin_group",
  "examination_skin_condition",
  "examination_skin_conditions",
  "examination_smoking",
  "examination_smoking_conditions",
  "treatment_plan_icd",
  "treatment_plan_icd_other", 
  "followup_plan_icd",
  "followup_plan_icd_other"
];

export const fieldsToInsert = [
  "has_had_examination",
  "examination_fitzpatrick_skin_type",
  "examination_glogau_skin_group",
  "examination_skin_condition",
  "examination_skin_conditions",
  "examination_smoking",
  "examination_smoking_conditions",
  "examination_facial_volume",
  "examination_facial_volume_details",
  "examination_abnormal",
  "examination_abnormal_conditions",
];